import React from 'react'
import OtpInput from 'react-otp-input'

const TwoFactorInput = React.forwardRef(
  ({ value, onChangeVal = () => {}, numInputs = 6, ...rest }, ref) => {
    return (
      <OtpInput
        value={value}
        onChange={(otp) => onChangeVal(otp)}
        numInputs={numInputs}
        isInputNum={true}
        shouldAutoFocus
        inputStyle={{
          width: '2.5rem',
          height: '2.5rem',
          fontSize: '1.5rem',
          margin: '0.5rem',
          textAlign: 'center',
          border: '1px solid #ccc',
          borderRadius: '4px',
          backgroundColor: '#fff',
          color: '#000',
        }}
        renderInput={(props) => <input {...props} />}
        ref={ref}
        {...rest}
      />
    )
  }
)

export default TwoFactorInput
